import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import NavMenu from './nav-menu';
import DownIcon from 'grommet/components/icons/base/Down';
import UpIcon from 'grommet/components/icons/base/Up';
import LeftIcon from 'grommet/components/icons/base/Previous';
import RightIcon from 'grommet/components/icons/base/Next';
import Utils from 'medscape/utils';
import {Link as RouterLink} from 'react-router-dom';
import InfoSiteHelpers from 'infosite/helpers';
import IsiActions from 'infosite/isi/actions';
import Tracking from 'medscape/tracking';

export default class Link extends React.Component {
    constructor(props){
        super(props);
    }
    componentWillUnmount(){
        let $this = $(ReactDOM.findDOMNode(this));
        let $link= $this.find('a');
        $link.off('click.route');
    }
    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));

    }
    componentDidUpdate(prevProps, prevState){
    }

    getArrowIcon(){
        const data = this.props.item;
        let hasSubmenu = (data.submenu && data.submenu.length>0);
        let ArrowIcon = DownIcon;
        if(hasSubmenu){
            if(this.props.position=="left" && this.props.submenuType!="inline"){
                ArrowIcon = RightIcon;
            }
            else if(this.props.position=="right" && this.props.submenuType!="inline"){
                ArrowIcon = LeftIcon;
            }
            else if(this.props.isExpandedSubmenu){
                ArrowIcon = UpIcon;
            }
            else{
                ArrowIcon = DownIcon;
            }

            return (
                <span className="arrow-container"><ArrowIcon /></span>
            )
        }
        else{
            return (
                <span className="arrow-container"></span>
            )
        }
    }
    render(){
        const data = this.props.item;
        let _target = data.target || '';
        let linkLabel = Utils.getDangerousHtml(data.label);
        let hasSubmenu = (data.submenu && data.submenu.length>0);
        let arrowIcon = this.getArrowIcon();
        let pageLink = "nav-link";
        let isiLink = (this.props.item.module=="IsiLink");
        
        if (isiLink) {
            pageLink = "nav-isi_link";
        } else if(data.url.length==0){
            pageLink = "nav-submenu"
        }

        let linkContainerProps = {
            className: 'link-container',
            onClick: (e)=>{
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                this.props.onToggleSubmenu(e,data);
                
            }
        }
        const isRouterLink = data.module=="RouterLink";

        let linkClass = cx({
            "title": true,
            "default-link": !isRouterLink,
            "router-link": isRouterLink,
            "js-tracking": isiLink || isRouterLink
        })



        let linkProps = {
            to: isRouterLink ? data.url : null,
            target: (!isRouterLink  && data.url.length > 0 ? data.target : null),
            className: linkClass,
            dangerouslySetInnerHTML: linkLabel,
            "data-wmdpagelink": pageLink,
            onClick: (e)=>{
                let el = e.currentTarget;

                Tracking.pageLink(pageLink, el);

                if(this.props.item.module=="IsiLink"){
                    e.preventDefault();
                    IsiActions.linkClick();
                }
            }
        }
        
        if (!isRouterLink && data.url.length > 0) {
            // Remove protocol on external URLs
            linkProps.href = data.url;
        }

        if(isRouterLink){
            return (
                <span {...linkContainerProps}>
                    <RouterLink {...linkProps} />{arrowIcon}
                </span>
            )
        }
        else{
            // PPE-174979
            // Use <div> to allow Dev App Navigation to not redirect to error page when href is 'unknown'
            return (
                <span {...linkContainerProps}>
                    <a {...linkProps}></a>{arrowIcon}
                </span>
            )
        }
    }

   
} // ListItem
Link.propTypes={
    item: React.PropTypes.object.isRequired,
    onToggleSubmenu: React.PropTypes.func,
    isMouseEnterEvent: React.PropTypes.bool,
    isExpandedSubmenu: React.PropTypes.bool,
    position: React.PropTypes.string,
    submenuType: React.PropTypes.string
}
Link.defaultProps={
    isExpandedSubmenu: false,
    position: "top",
    submenuType: "inline"

}



// WEBPACK FOOTER //
// ./src/app/navigation/link.jsx